// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IClientReactionsToOfferSchema {
  /** Комментарий клиента к объявлению в расшаренной подборке **/
  comment?: string;
  /** Реакция типа лайк/дизлайк к объявлению в расшаренной подборке **/
  likeDislikeReaction?: ELikeDislikeReaction;
}

export enum ELikeDislikeReaction {
  /** "Отметка, что объявление не понравилось клиенту **/
  'Dislike' = 'dislike',
  /** Отметка, что объявление понравилось клиенту **/
  'Like' = 'like',
}
